import Vue from 'vue'
import VueApollo from 'vue-apollo'
import ApolloClient from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { onError } from 'apollo-link-error'
import { InMemoryCache } from 'apollo-cache-inmemory'
import store from '@/store'

Vue.use(VueApollo)

const errorLink = onError(({ graphQLErrors, operation, networkError }) => {
  if (networkError) {
    console.error('[Network error]:', networkError)
  }
  if (graphQLErrors) {
    store.dispatch('apolloErrors/addError', graphQLErrors)
  }
})

const httpLink = new HttpLink({
  uri: '/graphql',
  credentials: 'include'
})

const cache = new InMemoryCache()

const apolloClient = new ApolloClient({
  link: errorLink.concat(httpLink),
  cache
})

export default new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $query: {
      loadingKey: 'loading',
      fetchPolicy: 'cache-and-network'
    }
  },
  errorHandler (error) {
    return error.toString()
  },
  prefetch: false
})
